<template>
  <div class="hpanel">
    <div class="panel-heading " @click="showHide" style="cursor: pointer">
      The Biblio  <span v-if="nbDoc"> - <span class="text-info"> {{nbDoc}} Document(s)</span> </span>
      <div class="pull-right text-right">
        <template v-if="boxOpen">
          <div class="btn-group hidden-xs hidden-sm" style="margin-right: 15px">
            <button class="btn btn-xs btn-info btn-outline" @click="preview"><i class="fa fa-eye"></i> Preview</button>
            <button class="btn btn-xs btn-info btn-outline" @click="pdf"><i class="fa fa-file-pdf-o"></i> PDF</button>
            <button class="btn btn-xs btn-info btn-outline" @click="svg"><i class="fa fa-image"></i> Image</button>
            <button class="btn btn-xs btn-info btn-outline" @click="exportJson"><i class="glyphicon glyphicon-export"></i> Export</button>
            <button class="btn btn-xs btn-info btn-outline" @click="importJson"><i class="glyphicon glyphicon-import"></i> Import</button>
            <button v-if="!$user.isOrange() && !$user.isSe()" class="btn btn-xs btn-info btn-outline" @click="getAllTechnoLockIn" title="Automated extraction of tech/sci problems contained in abstracts (Beta)"><i class="fa fa-share-square"></i> Extract</button>
          </div>
          <div class="btn-group hidden-xs">
            <button class="btn btn-xs btn-info btn-outline" @click="history"><i class="fa fa-history"></i> History</button>
            <button class="btn btn-xs btn-info btn-outline" @click="undo"><i class="fa fa-reply"></i> Undo</button>
            <button class="btn btn-xs btn-info btn-outline" @click="redo"><i class="fa fa-mail-forward"></i> Redo</button>
            <button class="btn btn-xs btn-info" @click="addKeyword"><i class="fa fa-plus"></i> Add keyword</button>
          </div>
          <div class="btn-group" style="margin-left: 20px">
            <button class="btn btn-xs btn-info btn-outline" @click="fullScreen"><i id="iconFullScreen" class="fa fa-expand"></i></button>
          </div>
        </template>
        <button type="button" class="btn btn-info btn-outline btn-xs showhide">
          <i class="fa fa-chevron-up"></i>
        </button>

      </div>
    </div>
    <div class="panel-body">
      <biblio :listId="listId" :project="project" :height="height" ref="biblio" @updateNbDoc="updateNbDoc"></biblio>
    </div>

  </div>
</template>

<style>
</style>
<script>

import Biblio from './Biblio'
export default {
  components: {Biblio},
  props: ['listId', 'project', 'height'],
  name: 'BiblioBox',
  data () {
    return {
      boxOpen: true,
      nbDoc: 0
    }
  },
  methods: {
    addKeyword: function (e) {
      this.$refs.biblio.showModalAddKeyword()
      e.preventDefault()
      e.stopPropagation()
    },
    preview: function (e) {
      this.$refs.biblio.preview()
      e.preventDefault()
      e.stopPropagation()
    },
    pdf: function (e) {
      this.$refs.biblio.pdf()
      e.preventDefault()
      e.stopPropagation()
    },
    svg: function (e) {
      this.$refs.biblio.exportImage()
      e.preventDefault()
      e.stopPropagation()
    },
    getAllTechnoLockIn: function (e) {
      this.$refs.biblio.getAllTechnoLockIn()
      e.preventDefault()
      e.stopPropagation()
    },
    exportJson: function (e) {
      this.$refs.biblio.showModalExportJson()
      e.preventDefault()
      e.stopPropagation()
    },
    importJson: function (e) {
      this.$refs.biblio.showModalImportJson()
      e.preventDefault()
      e.stopPropagation()
    },
    undo: function (e) {
      this.$refs.biblio.undo()
      e.preventDefault()
      e.stopPropagation()
    },
    redo: function (e) {
      this.$refs.biblio.redo()
      e.preventDefault()
      e.stopPropagation()
    },
    fullScreen: function (e) {
      this.$refs.biblio.fullScreen(e)
      e.preventDefault()
      e.stopPropagation()
    },
    history: function (e) {
      this.$refs.biblio.history()
      e.preventDefault()
      e.stopPropagation()
    },
    showHide: function (event) {
      if (event !== null) {
        event.preventDefault()
      }

      let hpanel = $(this.$el).closest('div.hpanel')
      let iconUp = $(this.$el).find('.fa-chevron-up')
      let iconDown = $(this.$el).find('.fa-chevron-down')
      let body = hpanel.find('div.panel-body:first')

      if (typeof iconUp !== 'undefined' && iconUp.length !== 0) {
        iconUp.toggleClass('fa-chevron-down').toggleClass('fa-chevron-up')
        this.boxOpen = false
      } else if (typeof iconDown !== 'undefined' && iconDown.length !== 0) {
        iconDown.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down')
        this.boxOpen = true
      }

      if (this.boxOpen === true) {
        this.$refs.biblio.resize()
      }

      body.slideToggle(300)
      hpanel.toggleClass('').toggleClass('panel-collapse')

      localStorage.setItem('biblioBoxOpen', this.boxOpen)
    },
    updateNbDoc: function (val) {
      this.nbDoc = 0
      if (val) {
        let biblioContent = JSON.parse(val)
        Object.keys(biblioContent).forEach((node) => {
          if (biblioContent[node].documents) {
            this.nbDoc += Object.keys(biblioContent[node].documents).length
          }
          if (biblioContent[node].uploadFiles) {
            this.nbDoc += Object.keys(biblioContent[node].uploadFiles).length
          }
        })
      }
    }
  },
  beforeMount () {
    this.boxOpen = localStorage.getItem('biblioBoxOpen')

    if (this.boxOpen === null) {
      this.boxOpen = true
    } else {
      this.boxOpen = this.boxOpen === 'true'
    }
  },
  mounted () {
    if (this.boxOpen === false) {
      this.showHide(null)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/biblio/BiblioBox.vue